import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext'
import { CookieConsentProvider } from './contexts/CookieConsentContext'
import { initCapacitor } from './mobile/capacitor'
import { initializeAppPushListeners } from './services/pushNotifications'
import NativeSplashHandoff from './components/mobile/NativeSplashHandoff'
import { initializeGoogleConsentMode } from './lib/consent/googleTag'

// Note: Sentry is now initialized via CookieConsentProvider when analytics consent is granted

initCapacitor()
void initializeAppPushListeners()
initializeGoogleConsentMode()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <CookieConsentProvider>
        <App />
        <NativeSplashHandoff />
      </CookieConsentProvider>
    </AuthProvider>
  </StrictMode>
)
